module.exports = __webpack_public_path__ + "static/media/capacidad.5dd4f622.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/capacidad.svg
// module id = 120
// module chunks = 0